import {Radio, FormControlLabel} from "@mui/material";
import {CheckboxLabel} from "./RadioInput.styles";
import React from "react";
import clsx from "clsx";

interface RadioInputProps {
    className?: string;
    checked?: boolean;
    name?: string;
    label?: any;
    radio?: boolean;
    value: string | number | boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const commonRadioProps = {
    icon: <img id="circleUnchecked" className="hidden-icon" alt="circleUnchecked" src={"img/circleUnchecked.svg"}/>,
    checkedIcon: <img id="circleChecked" className="hidden-icon" alt="circleChecked" src={"img/circleChecked.svg"}/>
}

export const RadioInput = ({className, label, name, value, onChange, checked, ...props}: RadioInputProps) => {
    const labelElement = typeof label === 'string' ? <CheckboxLabel>{label}</CheckboxLabel> : label;

    return (
        <FormControlLabel
            className={clsx("no-fastclick", className)}
            value={value}
            control={<Radio
                name={name}
                onChange={onChange}
                {...props}
                {...commonRadioProps}
            />}
            label={labelElement}
        />
    );
}